<div class="row">
  <div class="column">
    <pre>
        {{ jsonObject | json }}
    </pre>
  </div>
  <!-- <div class="column">
    <pre>
        {{ xmlObject }}
    </pre>
  </div> -->
</div>
